import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgChartModule } from '@cmps/ng-chart';
import {
    CmpsIconModule,
    CmpsPortalModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsLazyI18nModule } from '../i18n/i18n.module';
import { CmpsInsightModule } from '../insight/insight.module';
import { CmpsLazyRouterModule } from '../route.module';
import { CmpsUserModule } from '../user/user.module';

import { GridHumanInsightComponent } from './grid.hi.component';
import { HumanInsightComponent } from './human-insight.component';
import { TranslationIdMap } from './human-insight.i18n';
import { SuperGroupHumanInsightComponent } from './super-group.hi.component';
import { TrendHumanInsightComponent } from './trend.hi.component';
import { VisualHumanInsightComponent } from './visual.hi.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgChartModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsLazyRouterModule.forChild([]),
        CmpsUserModule,
        CmpsInsightModule,
        CmpsIconModule,
        CmpsPortalModule,
        CmpsTooltipModule,
    ],
    declarations: [
        SuperGroupHumanInsightComponent,
        VisualHumanInsightComponent,
        GridHumanInsightComponent,
        TrendHumanInsightComponent,
        HumanInsightComponent,
    ],
    exports: [HumanInsightComponent],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        // NO_ERRORS_SCHEMA
    ],
})
export class CmpsHumanInsightModule {}
